import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Muted } from './ui'
import { UNKNOWN_PRICE_TEXT, balanceOf, formatCredits, partsText, priceOf, usePrices } from '../model/pricing'

// What one sample's start costs, with its parts: "Credits 14  Whole exome 1 + CNV 6
// + AI 7". Used under the one-sample editor. A price the server does not expose yet
// reads "Confirmed at start"; nothing shows until the prices have loaded, or for a
// group analysis. `prices` (from usePrices) is optional: without it the component
// reads the shared /organisation/details query itself.

const SampleCredits = ({ workflow, sample, prices: given, sx }) => {
  const fetched = usePrices()
  const prices = given === undefined ? fetched : given
  if (!prices || !sample) return null
  const { credits, parts } = priceOf(workflow, sample, prices)
  if (!parts.length) return null
  const balance = balanceOf(prices)
  const short = credits !== null && balance !== null && credits > balance
  // One part is the whole price; its name alone says what it is for.
  const detail = parts.length > 1 ? partsText(parts) : parts[0].label

  return (
    <Box sx={{ maxWidth: 880, ...sx }} data-testid="sample-credits">
      <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', columnGap: 1.5, rowGap: 0.25 }}>
        <Typography sx={{ fontSize: 14.5, fontWeight: 600 }}>Credits</Typography>
        <Typography sx={{ fontSize: 14.5, fontVariantNumeric: 'tabular-nums' }}>
          {credits === null ? UNKNOWN_PRICE_TEXT : formatCredits(credits)}
        </Typography>
        {credits !== null && <Muted component="span">{detail}</Muted>}
      </Box>
      {short && (
        <Typography sx={{ fontSize: 13, color: 'error.main', mt: 0.5 }}>
          {`Balance ${formatCredits(balance)} is not enough for this start.`}
        </Typography>
      )}
    </Box>
  )
}

export default SampleCredits
